import { render } from "./BaseBadge.vue?vue&type=template&id=cf18bd58"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=cf18bd58&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/BaseBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf18bd58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf18bd58', __exports__)) {
    api.reload('cf18bd58', __exports__)
  }
  
  module.hot.accept("./BaseBadge.vue?vue&type=template&id=cf18bd58", () => {
    api.rerender('cf18bd58', render)
  })

}


export default __exports__